import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export type StepHeaderCopy = {
  eyebrow: string;
  titleStart: string;
  titleAccent: string;
  subtitle: string;
};

export function StepHeader({ copy }: { copy: StepHeaderCopy }) {
  return (
    <Stack spacing={1}>
      <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 1.5, fontWeight: 700, fontSize: 11, lineHeight: 1 }}>
        {copy.eyebrow}
      </Typography>
      <Typography variant="h4" fontWeight={700} sx={{ letterSpacing: -0.5, lineHeight: 1.15 }}>
        {copy.titleStart}{' '}
        <Box component="span" sx={{ color: 'primary.main' }}>
          {copy.titleAccent}
        </Box>
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5, maxWidth: 520 }}>
        {copy.subtitle}
      </Typography>
    </Stack>
  );
}
